import entities from '~/crud/entities'
import Api from '~/api'
import { Map, List, fromJS } from 'immutable'

export function onChange(formId, data) {
  let { name, value } = data.target || data
  return {
    type: 'FORM_ON_CHANGE',
    formId,
    name,
    value,
  }
}

export function onBatchChange(formId, values) {
  return {
    type: 'FORM_ON_BATCH_CHANGE',
    formId,
    values,
  }
}

export function onSubmit(formId) {
  return {
    type: 'FORM_ON_SUBMIT',
    formId,
  }
}

export function isLoading(formId, loading = true) {
  return {
    type: 'FORM_SUBMIT_LOADING',
    formId,
    loading,
  }
}

export function resetForm(formId) {
  return {
    type: 'FORM_RESET',
    formId,
  }
}

export function formSuccess(formId) {
  return {
    type: 'FORM_SUBMIT_SUCCESS',
    formId,
  }
}

export function formError(formId, { messages = List(), errors = Map() }) {
  return {
    type: 'FORM_SUBMIT_ERROR',
    formId,
    messages,
    errors,
  }
}

export function formMessages(formId, messages = []) {
  return {
    type: 'FORM_SET_MESSAGES',
    formId,
    messages,
  }
}

export function init(formId, values) {
  return {
    type: 'FORM_INIT',
    formId,
    values,
  }
}

export function setMeta(formId, meta) {
  return {
    type: 'FORM_SET_META',
    formId,
    meta,
  }
}

/**
 * Reference
 */

export function loadReferenceData(id, options = {}) {
  return async (dispatch, getState) => {
    dispatch(loadReferenceDataLoading(id, true))
    let referenceData = getState().formData.getIn(['_referenceData', id], false)
    if (List.isList(referenceData)) return

    try {
      let { data } = await Api.get('/resource', options)
      if (data.success) {
        dispatch(loadReferenceDataSuccess(id, data.items))
      } else {
        dispatch(loadReferenceDataError(id, data.message || `Problem when fetching reference ${id}`))
      }
    } catch (err) {
      console.log(err)
      dispatch(loadReferenceDataError(id, err.message || `Problem when fetching reference ${id}`))
    }

    dispatch(loadReferenceDataLoading(id, false))
  }
}

export function loadReferenceDataLoading(id, loading = true) {
  return {
    type: 'FORM_LOAD_REFERENCE_DATA_LOADING',
    id,
  }
}

export function loadReferenceDataSuccess(id, items) {
  return {
    type: 'FORM_LOAD_REFERENCE_DATA_SUCCESS',
    id,
    items,
  }
}

export function loadReferenceDataError(id, message) {
  return {
    type: 'FORM_LOAD_REFERENCE_DATA_ERROR',
    id,
    message,
  }
}

/**
 * Links
 */

export function loadLinksData(id, options = {}) {
  return async (dispatch, getState) => {
    dispatch(loadLinksDataLoading(id, true))
    let linksData = getState().formData.getIn(['_linksData', id], false)
    if (Map.isMap(linksData)) return

    try {
      let { data } = await Api.get('/links', options)
      if (data.success) {
        dispatch(loadLinksDataSuccess(id, data.data))
      } else {
        dispatch(loadLinksDataError(id, data.message || `Problem when fetching links ${id}`))
      }
    } catch (err) {
      console.log(err)
      dispatch(loadLinksDataError(id, err.message || `Problem when fetching links ${id}`))
    }

    dispatch(loadLinksDataLoading(id, false))
  }
}

export function loadLinksDataLoading(id, loading = true) {
  return {
    type: 'FORM_LOAD_LINKS_DATA_LOADING',
    loading,
    id,
  }
}

export function loadLinksDataSuccess(id, data) {
  return {
    type: 'FORM_LOAD_LINKS_DATA_SUCCESS',
    id,
    data,
  }
}

export function loadLinksDataError(id, message) {
  return {
    type: 'FORM_LOAD_LINKS_DATA_ERROR',
    id,
    message,
  }
}
